import { Command } from 'commander';
import { GenerateTransformationCommand } from './generateTransformationCommand';

export function TransformationCommand(): Command {
  const cmd = new Command('transformation');
  cmd.alias('tr').description('Transformation related commands.');

  cmd.addCommand(GenerateTransformationCommand());
  return cmd;
}
